import DetailsClassInfoSection from './DetailsClassInfoSection';
import { DetailsClassInfoSectionProps, DetailsClassInfoSectionValueProps } from './types';

export type { DetailsClassInfoSectionProps, DetailsClassInfoSectionValueProps };
export default DetailsClassInfoSection;
